export const getSalary = function getSalery(rate, vacation, occupancyRate, pensionProvision) {
    return ((2024 - vacation * 8) * rate * occupancyRate * 0.85 - pensionProvision * 12 * 1.2426) / 1.3142 / 12;
}